export const getUpdatedAtDate = ({
  publicationDate,
  updatedAtDate,
  announcementDate,
}: {
  publicationDate: string | undefined | null;
  updatedAtDate: string | undefined | null;
  announcementDate: string | undefined | null;
}) => {
  if (
    updatedAtDate &&
    publicationDate &&
    new Date(updatedAtDate).getTime() < new Date(publicationDate).getTime()
  ) {
    return publicationDate;
  }

  if (
    announcementDate &&
    updatedAtDate &&
    new Date(updatedAtDate).getTime() < new Date(announcementDate).getTime()
  ) {
    return announcementDate;
  }

  return updatedAtDate || publicationDate || announcementDate;
};
